<template>
  <form class="form form-vertical">
    <div class="form-body">
      <div class="row">
        <div class="w-full mt-5 mb-5">
          <vs-row>
            <vs-col vs-w="12">
              <!-- Name -->
              <vx-input-group class="mb-5">          
                <vs-input
                  label="Nome do Cargo"
                  v-model="role.display_name"
                  class="w-full"
                  name="Nome do Cargo"
                  v-validate="'required'"
                  :disabled="role.display_name === 'Administrador' || role.display_name === 'Atendente'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Nome do Cargo')"
                >
                  {{ errors.first('Nome do Cargo') }}
                </span>
              </vx-input-group>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-checkbox 
              v-model="selectAll" 
              class="mb-5" 
              @change="selectAllPermissions"
            >
              Selecionar Todas as Permissões
            </vs-checkbox>
          </vs-row>

          <vs-row>
            <vs-col
              v-for="(category, index) in categories"
              :key="`category-card${index}`"
              vs-w="6"
            >
              <vs-card style="width: 97%;">
                <div slot="header">
                  <h4 class="w-full flex justify-start">
                    <vs-checkbox 
                      v-model="selectAllCategory[category]" 
                      class="mb-5" 
                      @change="selectAllCategoryPermissions(category)"
                    >
                      {{ category.replace(/\//ig, ' / ') }}
                    </vs-checkbox>
                    <div>
                      <vx-tooltip
                          delay=".2s"
                          color="gray"
                          id="tooltip"
                          position="bottom"
                          :text="allPermissions[category][0].descriptionCategory"
                      >
                          <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey" style="display: inline-block;"></feather-icon>
                      </vx-tooltip>
                    </div>
                  </h4>
                </div>
                <div 
                  class="w-full flex justify-start"
                  v-for="permission in allPermissions[category]"
                  :key="`permission-checkbox${permission.id}`">
                  <vs-checkbox 
                    
                    v-model="selectedPermissions" 
                    :vs-value="permission.id"
                    class="mt-2 mb-2"
                    @change="checkListPermission(permission, allPermissions[category], category)"
                    :disabled="permission.checkbox_disabled && selectedPermissions.indexOf(permission.id) === -1"
                  >
                    {{ permission.display_name }}
                  </vs-checkbox>
                  <div v-if="permission.description !== null">
                    <vx-tooltip
                        delay=".2s"
                        color="gray"
                        id="tooltip"
                        position="bottom"
                        :text="permission.description"
                    >
                        <feather-icon icon="HelpCircleIcon" svgClasses="w-5 h-4 text-grey" style="display: inline-block;"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>

          <!-- <vs-row>
            <vs-col>
              <vs-card style="width: 50%;">
                
                <VuePerfectScrollbar ref="verticalNavMenuPs" class="scroll-area-v-nav-menu pt-2" :settings="settings" @ps-scroll-y="psSectionScroll" :key="$vs.rtl">
                  <template v-for="(item, index) in menuItemsUpdated">

                    <span v-if="item.header && !verticalNavMenuItemsMin" class="navigation-header truncate" :key="`header-${index}`">
                      {{ $t(item.i18n) || item.header }}
                    </span>

                    <template v-else-if="!item.header">

                      <v-nav-menu-item
                        v-if="!item.submenu"
                        :key="`item-${index}`"
                        :index="index"
                        :to="item.slug !== 'external' ? item.url : null"
                        :href="item.slug === 'external' ? item.url : null"
                        :icon="item.icon" :target="item.target"
                        :isDisabled="item.isDisabled"
                        :slug="item.slug"
                        :isLink="false"
                        :activeLink="false"
                      >
                        <span v-show="!verticalNavMenuItemsMin" class="ml-3 menu-text-perm">{{ $t(item.i18n) || item.name }}</span>
                      </v-nav-menu-item>

                      <template v-else>
                        <v-nav-menu-group
                          :key="`group-${index}`"
                          :openHover="false"
                          :group="item"
                          :groupIndex="index"
                          :open="isGroupActive(item)"
                          :marginIcon="true"
                        />
                      </template>
                    </template>
                  </template>
                </VuePerfectScrollbar>

              </vs-card>
            </vs-col>
          </vs-row> -->

          <!-- Submit -->
          <vx-input-group>
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
              Salvar
            </vs-button>
          </vx-input-group>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { formatRouteTenantPath } from '@/utils'
  import moduleRole from '@/store/role/moduleRole'
  import modulePermission from '@/store/permission/modulePermission'

  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import VNavMenuGroup from '@/layouts/components/vertical-nav-menu/VerticalNavMenuGroup.vue'
  import VNavMenuItem from '@/layouts/components/vertical-nav-menu/VerticalNavMenuItem.vue'

  export default {
    name: 'role-form',
    data() {
      return {
        settings: {      // perfectScrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: 1,
          swipeEasing: true
        },
        showShadowBottom: false,
        isMouseEnter: false,
        reduce: false, // determines if navMenu is reduce - component property
        role: {
          display_name: ''
        },
        categories: [],
        allPermissions: [],
        selectedPermissions: [],
        startSelectedPermissions: 0,
        isSaved: false,
        selectAll: false,
        selectAllCategory: {}
      }
    },
    computed: {
      isFormValid() {
        return !this.errors.any()
      },
      permissions() {
        return this.$store.state.permission 
          ? this.$store.state.permission.permissions
          : []
      },
      verticalNavMenuItemsMin() {
        return this.$store.state.verticalNavMenuItemsMin
      },
      navMenuItems() {
        return this.$store.state.layout.navMenuItems || []
      },
      menuItemsUpdated() {
        let clone = this.navMenuItems.slice()

        for(let [index, item] of this.navMenuItems.entries()) {
          if (item.header && item.items.length && (index || 1)) {
            let i = clone.findIndex(ix => ix.header === item.header)
            for(let [subIndex, subItem] of item.items.entries()) {
              clone.splice(i + 1 + subIndex, 0, subItem)
            }
          }
        }

        return clone
      },
      isGroupActive() {
        return (item) => {
          const path        = this.$route.fullPath
          const routeParent = this.$route.meta ? this.$route.meta.parent : undefined
          let open          = false

          let func = (item) => {
            if (item.submenu) {
              item.submenu.forEach((item) => {
                if (item.url && (path === item.url || routeParent === item.slug)) { open = true }
                else if (item.submenu) { func(item) }
              })
            }
          }
          func(item)
          return open
        }
      },
    },
    watch: {
      permissions: function (allPermissions) {
        const permissions = []

        allPermissions
          .map(permission => {
            const categoryName = permission.category.name

            if (permissions.indexOf(categoryName) === -1) {
              permissions[categoryName] = []
              this.selectAllCategory[categoryName] = false
            }
          })

        allPermissions
          .map(permission => {
            const categoryName = permission.category.name
            const descriptionCategory = permission.category.description
            let checkboxDisabled = false;
            
            permissions[categoryName].map(perm => {
              if (
                perm.name.startsWith('listagem-') &&
                this.selectedPermissions.indexOf(perm.id) < 0
                ) {
                  checkboxDisabled = true;
                }
              })
            
            permissions[categoryName].push({
              id: permission.id,
              name: permission.name,
              display_name: permission.display_name,
              checkbox_disabled: checkboxDisabled,
              description: permission.description,
              descriptionCategory: descriptionCategory
            })
          })

        this.allPermissions = permissions
        this.categories = Object.keys(permissions) || []
        this.categories.map(categoryName => {
          let selectedPermissionsCategory = 0

          permissions[categoryName].map(perm => {
            if (this.selectedPermissions.indexOf(perm.id) >= 0) {
              selectedPermissionsCategory++
            }
          })

          if (permissions[categoryName].length === selectedPermissionsCategory) {
            this.selectAllCategory[categoryName] = true
          }
        })
      },
    },
    methods: {
      psSectionScroll() {
        this.showShadowBottom = this.$refs.verticalNavMenuPs.$el.scrollTop > 0 ? true : false
      },
      submitData() {
        const role = this.$_.cloneDeep(this.role)
        role.selectedPermissions = this.selectedPermissions.map(p => p);

        this.$validator.validateAll().then(result => {
          if (result) {
            if (role.id !== null && role.id >= 0) {
              // Edit
              this.$store.dispatch("role/update", role).then(() => {
                this.$vs.notify({
                  color: 'success',
                  title: 'Sucesso!',
                  text: 'Permissão atualizada com sucesso!'
                });
                // Redirect to list page
                this.isSaved = true
                this.$router.push(formatRouteTenantPath("/roles/list"))
              }).catch(err => {
                console.error(err)
              })
            } else {
              // New
              delete role.id

              this.$store.dispatch("role/add", role).then(() => {
                this.$vs.notify({
                  color: 'success',
                  title: 'Sucesso!',
                  text: 'Permissão adicionada com sucesso!'
                });
                // Redirect to list page
                this.isSaved = true
                this.$router.push(formatRouteTenantPath("/roles/list"))
              }).catch(err => {
                console.error(err)
              })
            }
          }
        })
      },
      selectAllPermissions() {
        const selectAll = this.selectAll
        
        if (selectAll) {
          this.selectedPermissions = this.permissions.map(p => p.id)
        } else {
          this.selectedPermissions = []
        }
      },
      selectAllCategoryPermissions(category) {
        const permissions = this.allPermissions[category].map(p => p.id)

        if (this.selectAllCategory[category]) {
          this.selectedPermissions = [
            ...this.selectedPermissions,
            ...permissions
          ]

          // this.selectAllCategory[category] = true
        } else {
          this.selectedPermissions = this.selectedPermissions.filter(pId => 
            permissions.indexOf(pId) === -1
          )

          // this.selectAllCategory[category] = false
        }

        if (category === 'Chat/Chat de Atendimento') {
          this.checkListPermission(
            this.allPermissions[category][0],
            this.allPermissions[category],
            category
          )
        }
        this.removeClone(this.selectedPermissions);
      },
      removeClone(array) {
        this.selectedPermissions = Array.from(new Set(array));
      },
      checkListPermission(permission, categoryPermissions, categoryName) {
        const permIndex = this.selectedPermissions.indexOf(permission.id)

        // Caso tenha sido dada a permissão de Chat, tem que ativar a permissão de
        // "Listagem de Conexões" também
        if (permission.name.startsWith('utilizar-chat-de-atendimento')) {
          if (permIndex >= 0) {
            const connectionsListId = this.permissions.filter(perm => 
              perm.name === 'listagem-de-conexoes'
            )

            if (typeof connectionsListId[0] !== 'undefined') {
              if (this.selectedPermissions.indexOf(connectionsListId[0].id) === -1) {
                this.selectedPermissions.push(connectionsListId[0].id)
              }
            }
          }
        }


        if (categoryName.startsWith('Configurações/Ajustes')){
          if (!permission.name.startsWith('visualizar-configuracoes') && this.selectedPermissions.indexOf(permission.id) !== -1) {
              let viewConfig = this.allPermissions[categoryName].find(perm => {
                return perm.name === 'visualizar-configuracoes'
              })

              if (this.selectedPermissions.indexOf(viewConfig.id) === -1) {
                this.selectedPermissions.push(viewConfig.id)
              }

          } else if ( permission.name.startsWith('visualizar-configuracoes') && this.selectedPermissions.indexOf(permission.id) === -1 ) {
            categoryPermissions.map(perm => {
              const index = this.selectedPermissions.indexOf(perm.id)
              delete this.selectedPermissions[index]
            })
          }
        }
        
        if (permission.name.startsWith('listagem-')) {
          if (permIndex === -1) {

            this.allPermissions[categoryName] = this.allPermissions[categoryName].map(perm => {
              if (!perm.name.startsWith('listagem-')) {
                return {
                  ...perm,
                  checkbox_disabled: true
                }
              }

              return perm
            })

            categoryPermissions.map(perm => {
              const index = this.selectedPermissions.indexOf(perm.id)
              if (index >= 0) {
                delete this.selectedPermissions[index]
              }
            })

          } else {

            this.allPermissions[categoryName] = this.allPermissions[categoryName].map(perm => {
              if (!perm.name.startsWith('listagem-')) {
                return {
                  ...perm,
                  checkbox_disabled: false
                }
              }

              return perm
            })

          }
        }
      }
    },
    created() {
      if (!moduleRole.isRegistered) {
        this.$store.registerModule('role', moduleRole)
        moduleRole.isRegistered = true
      }

      if (!modulePermission.isRegistered) {
        this.$store.registerModule('permission', modulePermission)
        modulePermission.isRegistered = true
      }

      this.$store.dispatch("permission/fetch")

      const roleId = this.$route.params.id;

      // The following logic will only work on "update" page
      if (roleId) {
        this.$store
          .dispatch("role/infos", roleId)
          .then((res) =>{ 
            const { id, has_permissions, display_name } = res.data.data.roleInfos

            this.selectedPermissions = this.$_.cloneDeep(has_permissions)
            this.startSelectedPermissions = this.selectedPermissions.length
            this.role.id = id
            this.role.display_name = display_name

            if (this.selectedPermissions.length === this.permissions.length) {
              this.selectAll = true
            } 
          })
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.selectedPermissions.length !== this.startSelectedPermissions && !this.isSaved) {
        this.$vs.dialog({
          type:'confirm',
          color: 'primary',
          title: `Deseja sair da página?`,
          text: 'Atenção: Você possui alterações não salvas!',
          accept: () => next(),
          cancel: () => next(false),
          acceptText: 'Confirmar',
          cancelText: 'Voltar',
          buttonAccept: 'flat',
          buttonCancel: 'filled'
        })
      } else {
        next()
      }
    },
    components: {
      VuePerfectScrollbar,
      VNavMenuGroup,
      VNavMenuItem
    }
  }
</script>

<style>
button.button-remove-bg {
  color: #0B8FFA !important;
}

.menu-text-perm {
  font-size: 15px !important;
}

.vs-button-filled {
  color: #fff !important;
}
</style>